import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AlgoliaRecordHit } from '../../models/algolia-record-hit';
import { AlgoliaRecordHitService } from '../../services/algolia-record-hit.service';
import { InstantSearchService } from '../../services/instant-search.service';
import { Hit, InstantSearch, UiState, Widget } from 'instantsearch.js';
import { filter, map, Subscription } from 'rxjs';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits';
import { configure } from 'instantsearch.js/es/widgets';
import * as algoliasearchHelper from 'algoliasearch-helper';
import connectPagination from 'instantsearch.js/es/connectors/pagination/connectPagination';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';

interface IPaginationRenderOptions {
  pages: number[];
  currentRefinement: number;
  nbHits: number;
  nbPages: number;
  isFirstPage: boolean;
  isLastPage: boolean;
  canRefine: boolean;
  refine: (page: number) => void;
  createURL: (page: number) => string;
  widgetParams: object;
}

interface HitsRenderOptions {
  items: Hit[];
  results?: algoliasearchHelper.SearchResults<any>;
  banner?: any;
  sendEvent: (event: any) => void;
  widgetParams: object;
}

@Component({
  selector: 'app-search-result-list',
  standalone: false,
  templateUrl: './search-result-list.component.html',
  styleUrl: './search-result-list.component.scss'
})
export class SearchResultListComponent implements OnInit, OnDestroy {

  @Output() onListItemSelected = new EventEmitter<AlgoliaRecordHit>();

  @Input() id: string = 'search-result-list';
  @Input() isOnGlobalSearchPage: boolean = false;
  @Input() showPagination: boolean = false;

  readonly Math = Math;
  readonly viewAllIconName: string = materialSymbols.arrowForward;
  readonly searchIconName: string = materialSymbols.search;

  resultsPerPage: number = 20;

  showMoreFn: any = () => {};
  isLastPage: boolean = true;

  hits: Hit[] = [];
  algoliaRecordHits : AlgoliaRecordHit[] = [];
  paginationResult?: IPaginationRenderOptions;
  rawResults?: algoliasearchHelper.SearchResults<any>;

  subscriptions: Subscription = new Subscription();
  widgets: Widget[] = [];


  constructor(
    private _algoliaRecordHitService: AlgoliaRecordHitService,
    private _instantSearchService: InstantSearchService
  ) { }

  ngOnInit(): void {
    this.setupInstantSearchService();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

    console.log('SearchResultListComponent: Removing InstantSearch widgets');
    this._instantSearchService.instance?.removeWidgets(this.widgets);
  }

  setupInstantSearchService(): void {
    this.subscriptions.add(this._instantSearchService.instanceSubject$.pipe(
      filter((instance) => instance !== null),
      map((instance) => instance as InstantSearch<UiState, UiState>)
    ).subscribe({
      next: (instantSearchInstance: InstantSearch<UiState, UiState>) => {
        this.setupHitsWidget(instantSearchInstance);

        if (this.showPagination) {
          this.setupPaginationWidget(instantSearchInstance);
        }
      }
    }));
  }
  setupPaginationWidget(instantSearchInstance: InstantSearch<UiState, UiState>) : void {
    const customPagination = connectPagination(
      (renderOptions: IPaginationRenderOptions, isFirstRender: boolean) => {
        const {
          pages,
          currentRefinement,
          nbHits,
          nbPages,
          isFirstPage,
          isLastPage,
          canRefine,
          refine,
          createURL,
          widgetParams,
        } = renderOptions;

        if (isFirstRender) {

        }

        console.log("Pagination render:", renderOptions)
        this.paginationResult = renderOptions;
      }
    );

    const customPaginationWidget = customPagination({});
    instantSearchInstance.addWidgets([customPaginationWidget])
    this.widgets.push(customPaginationWidget);

  }

  setupHitsWidget(instantSearchInstance: InstantSearch<UiState, UiState>): void {
    var customHits = connectHits(
      (renderOptions: HitsRenderOptions, isFirstRender: boolean) => {
        const { items, results, banner, sendEvent, widgetParams } = renderOptions;
        console.log('Hits render', { items, results, banner, sendEvent, widgetParams });
        this.hits = items;
        this.algoliaRecordHits = [...this.hits] as AlgoliaRecordHit[];
        this.rawResults = results;
      }
    );

    const hitsWidget = customHits({});
    const configureWidget = configure({
      hitsPerPage: this.resultsPerPage,
    });

    instantSearchInstance.addWidgets([
      hitsWidget,
      configureWidget
    ]);
    this.widgets.push(hitsWidget);
  }



  onSelectListItem(algoliaRecordHit: AlgoliaRecordHit) {
    this.onListItemSelected.emit(algoliaRecordHit);
  }

  preventParentClick(event: MouseEvent, hit: AlgoliaRecordHit): void {
    event.stopPropagation();

    this.onListItemSelected.emit(hit);
  }

  getSearchResultItemLink(hit: AlgoliaRecordHit): string {
    return this._algoliaRecordHitService.getSearchResultItemLink(hit);
  }

  onPageChange(pageNumber: number) {
    if (this.paginationResult?.refine) {

      this.paginationResult?.refine(pageNumber - 1);  // Subtract 1 because Algolia pages are zero based.
    }
  }
}
